import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/auth/login", form);
      toast.success("Hoş geldiniz");
      navigate("/admin");
      window.location.reload();
    } catch (err) {
      toast.error(errMsg(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0F1115] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-[#181B20] border border-[#272B33] rounded-2xl p-8">
        <div className="flex items-center gap-3 mb-8">
          <span className="bg-white rounded-xl px-3 py-2.5 inline-flex">
            <img src="/assets/bigeldi-logo.png" alt="BIGELDİ" className="h-7 w-auto object-contain" />
          </span>
          <div>
            <p className="text-sm font-semibold text-white">Yönetim Paneli</p>
            <p className="text-xs text-neutral-500">Güvenli giriş</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required placeholder="Admin e-posta" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full h-12 px-4 bg-[#0F1115] border border-[#272B33] rounded-xl text-sm text-white focus:outline-none focus:border-blue-500"
            data-testid="admin-login-email" />
          <input type="password" required placeholder="Şifre" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full h-12 px-4 bg-[#0F1115] border border-[#272B33] rounded-xl text-sm text-white focus:outline-none focus:border-blue-500"
            data-testid="admin-login-password" />
          <button type="submit" disabled={busy}
            className="w-full h-12 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-500 transition-colors disabled:opacity-50"
            data-testid="admin-login-submit">
            {busy ? "Giriş yapılıyor..." : "Panele Giriş"}
          </button>
        </form>
        <p className="text-[11px] text-neutral-600 mt-6 text-center">Bu alan yalnızca yetkili personel içindir. Tüm işlemler kayıt altına alınır.</p>
      </div>
    </div>
  );
}
